module.exports = __webpack_public_path__ + "static/media/05.40be636c.png";